export function changeBillionToCN(c) {
    //                对传参进行类型处理,非字符串进行转换
    c = parseInt(parseInt(c) / 100)
    if (typeof (c) != "string") {
        c = c.toString();
    }
    //                对参数进行判断,
    if (c.length <= 4) {
        return c
    } else if (c.length > 4 && c.length < 8) {
        return (c / 10000).toFixed(1) + "万";
    } else if (c.length >= 8 && c.length < 13) {
        return (c / 100000000).toFixed(1) + "亿";
    } else if (c.length >= 13) {
        return (c / 1000000000000).toFixed(1) + "万亿";
    }
}

import Vue from 'vue'

const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 3000)
            }
        })
    }
});

 export { preventReClick }
 export function mobile_rule(objValue) {
    var patn = /^1[0-9]{10}$/;
    if (patn.test(objValue))
        return true;
    return false;
}